<template>
  <ul class="uk-iconnav data-grid-actions uk-float-right">
    <slot name="before" />
    <li v-if="editable">
      <router-link v-if="editRoute" :to="editRoute">
        <icon name="pencil" />
      </router-link>
      <a href="#" v-else @click.prevent="$emit('edit')">
        <icon name="pencil" />
      </a>
    </li>
    <slot />
    <li v-if="removable">
      <router-link v-if="removeRoute" :to="removeRoute">
        <icon name="trash" />
      </router-link>
      <a href="#" v-else @click.prevent="$emit('remove')">
        <icon name="trash" />
      </a>
    </li>
    <slot name="after" />
  </ul>
</template>

<script>
export default {
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    removable: {
      type: Boolean,
      default: true,
    },
    editRoute: Object,
    removeRoute: Object,
  },
};
</script>

<style lang="scss" scoped>
.data-grid-actions {
  float: right;
}
</style>



// WEBPACK FOOTER //
// DataGridActions.vue?62ca10aa